import SitePosterPage from './SitePosterPage';

export * from './types';

export default SitePosterPage;
